import React, { useState, HTMLAttributes } from "react";
import classNames from "classnames";
// import { useSelector } from "react-redux";
import { StyledProfile, StyledPopover } from "./Profile.styled";
import { ReactComponent as ProfileIconSvg } from "../../../assets/icons/profile.svg";
import { ReactComponent as ArrowIcon } from "../../../assets/icons/arrow.svg";
import ProfileIcon from "../../atoms/ProfileIcon";
import { reset } from "../../../store/authStore/userData";
import MenuItem from "../../molecules/MenuItem";
// import { useAppDispatch } from "../../../store/store";
// import { SUserData } from "../../../store/selectors";

export interface IProfile extends HTMLAttributes<HTMLDivElement> {
  navigation: Array<any>;
  userPrincipal?: string;
  children: JSX.Element;
}

const Profile = ({
  navigation,
  userPrincipal,
  children,
  ...props
}: IProfile) => {
  // const user = useSelector(SUserData);
  // const dispatch = useAppDispatch();
  const [isOpen, setIsOpen] = useState(false);
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);

  const showNavigation = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
    setIsOpen(true);
  };

  const hideNavigation = () => {
    setAnchorEl(null);
    setIsOpen(false);
  };

  const handleLogout = () => {
    // localStorage.clear();
    // dispatch(reset());
    hideNavigation();
  };

  return (
    <StyledProfile {...props}>
      <div
        className={classNames("profileContainer", { isOpen })}
        onClick={showNavigation}
      >
        <ProfileIcon />
        {userPrincipal ? (
          <div className="profileName">
            {userPrincipal} <ArrowIcon width={10} />
          </div>
        ) : null}
        {/* {user.principal ? (
          <div className="profileName">
            {user.principal}
            <ArrowIcon width={10} />
          </div>
        ) : null} */}
      </div>
      <StyledPopover
        anchorEl={anchorEl}
        keepMounted
        open={isOpen}
        onClose={hideNavigation}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
      >
        <div className="profileMenu">
          {children}
          {/* {user.isAuthorised ? (
            navigation.map(({ Icon, text, link, action }) => (
              <MenuItem
                Icon={Icon}
                label={text}
                to={link}
                rounded={false}
                spacing={action === "logout" ? [1, 0] : 0}
                onClick={action === "logout" ? handleLogout : hideNavigation}
              />
            ))
          ) : (
            <MenuItem
              Icon={ProfileIconSvg}
              label="Connect"
              to="/connect"
              rounded={false}
              spacing={0}
              onClick={hideNavigation}
            />
          )} */}
        </div>
      </StyledPopover>
    </StyledProfile>
  );
};

export default Profile;
